<template>
  <main>
    <h2>Select a Database to work with</h2>
    <!-- Check that the SDK client is not currently loading before accessing is methods -->
    <div class="btn-wrapper-black">
      <a href="edit-sites">Sites</a>
    </div>
    <div class="btn-wrapper-black">
      <a href="edit-events">Events</a>
    </div>
    <div class="btn-wrapper-black">
      <a href="edit-courses">Classes</a>
    </div>
  </main>
</template>

<script>
export default {
  name: 'editselect',

  metaInfo: {
    title: "Edit",
    titleTemplate: "%s | Contrology | Balanced Body",
    meta: [
      {
        name: "robots",
        content: "noindex, nofollow"
      },
      {
        property: "og:image",
        content: "https://s3.amazonaws.com/s3.pilates.com/contrology/contrology-default.jpg"
      }
    ]
  }
}
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
}

.btn-wrapper-black {
  background-color: var(--black);
  border-radius: 3px;
  height: 56px;
  margin: 15px auto;
  width: 100%;
  max-width: 300px;
}

.btn-wrapper-black:hover a {
  color: #e7d49f;
}

a {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-family: var(--roboto);
  font-size: 0.9375rem;
  font-weight: 700;
  line-height: 1.2;
  color: var(--white);
  text-decoration: none;
  text-transform: uppercase;
  padding: 10px;
  cursor: pointer;
}
</style>